module.exports = __webpack_public_path__ + "img/certificate_content.01fa3104.png";